import React from 'react';
import { Row, Space } from 'antd';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { TitleSummary } from '../../style';
import { useDictionaryTranslation } from '../../../../hooks/useDictionaryTranslation';

const AssetComponent = ({ field }) => {
  const { translate: t } = useDictionaryTranslation();
  const { assetModule } = useSelector((state) => ({
    assetModule: state.auth.accountModules.asset,
  }));

  return (
    <>
      <React.Fragment key={field.idInput}>
        <TitleSummary>{field.label}</TitleSummary>
        <Row>
          <Space>
            <span>
              {[field?.valueObject?.reference?.trim?.(), field?.valueObject?.name?.trim?.()]
                .filter(Boolean)
                .join(' - ')}
            </span>
            {assetModule && field?.valueObject && !field.valueObject.isRemove ? (
              <Link to={`/assets/${field.value}/info`} target="__blank" rel="noopener noreferrer">
                {t('viewMore')}
              </Link>
            ) : null}
          </Space>
        </Row>
      </React.Fragment>
    </>
  );
};

export default AssetComponent;

AssetComponent.propTypes = {
  field: PropTypes.object.isRequired,
};
